import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import ActivityIcon from 'react-feather/dist/icons/activity'
import style from './LiveUpdateItem.css';
import {avatarUrl, readableDateTime} from "../utils/helpers";
import IconBadge from "./IconBadge";


export default class LiveUpdateItem extends PureComponent {
  propTypes = {
    live: PropTypes.object.isRequired,
  };


  render() {
    let {live} = this.props;
    let {last} = live;

    if (!last){
      return null;
    }

    return (
        <div className={style.item}>
          <div className={style.content_container}>
            <h4 className={style.title}>
              <Link to={'/lives/' + live.id}>
                {last ? last.title ? last.title : last.link.title : ''}
              </Link>
            </h4>

            <div className="d-flex align-items-center justify-content-between">
              <Link className={style.live_link} to={`/lives/${live.id}`}>
                <span className={style.byline}>{readableDateTime(last.publish_at)}</span>
                &nbsp;·&nbsp;
                {live.title}
              </Link>

              &nbsp;

              <IconBadge icon={<ActivityIcon/>} text={live.threads_count}/>
            </div>
          </div>

          <img className={style.avatar} src={avatarUrl(last)} width={40} height={40}/>
        </div>
    )
  }
}
